import React from 'react'
import PropTypes from 'prop-types'
import Markdown from 'markdown-to-jsx'
import hasKeys from '../../helpers/hasKeys'

import * as Styled from './AdditionalInformation.styles'

const WarrantyItem = props =>
  props.showMessage ? (
    <p data-text='warranty-footnote'>
      {props.message}
      <a className='a' href='http://www.compareextendedwarranties.co.uk' target='_blank' rel='noreferrer'>
        www.compareextendedwarranties.co.uk.
      </a>
    </p>
  ) : null

const LegalDisclaimer = props =>
  props.message ? (
    <>
      <br />
      <p data-text='legal-disclaimer'>{props.message}</p>
    </>
  ) : null

const GuaranteeDisclaimer = props =>
  props.hasProductCare && props.message ? (
    <>
      <br />
      <p data-text='guarantee-disclaimer'>{props.message}</p>
    </>
  ) : null

const ExclusionsWrapper = props => <p data-text='exclusion-text' {...props} />

const AdditionalInformation = ({ texts = {}, warrantyProductDetails, isWarrantyItem }) => {
  const {
    smallPrint = 'The small print',
    exclusionText,
    safetyText,
    pricesSubject = '*Prices correct as displayed but are subject to change.',
    priceFootNote,
    warrantyMessage = 'You can compare the prices of product care for your electrical goods online using any internet enabled device at ',
    answersDisclaimerMessage = 'The customer and brand answers you’ll see above are submitted independently. As we don’t review these answers, we can’t take responsibility for anything they may say. The responses from Argos colleagues are accurate at the time of publishing. For the latest info, you should check the product page.',
    guaranteeDisclaimerMessage = 'This product comes with a minimum one year manufacturer’s guarantee, unless otherwise stated in the specification above.'
  } = texts

  return (
    <Styled.Container data-test='additional-information'>
      <Styled.SmallPrint data-text='small-print'>{smallPrint}</Styled.SmallPrint>
      {exclusionText && (
        <Markdown options={{ wrapper: ExclusionsWrapper, forceWrapper: true }}>
          {exclusionText.replace(/<br\s*\/?>/gi, '<br>')}
        </Markdown>
      )}
      {safetyText && <p data-text='safety-text'>{safetyText}</p>}
      {pricesSubject && <p data-text='prices-subject'>{pricesSubject}</p>}
      {priceFootNote && <p data-text='price-footnote'>{priceFootNote}</p>}
      <WarrantyItem showMessage={isWarrantyItem} message={warrantyMessage} />
      <LegalDisclaimer message={answersDisclaimerMessage} />
      <GuaranteeDisclaimer message={guaranteeDisclaimerMessage} hasProductCare={hasKeys(warrantyProductDetails)} />
    </Styled.Container>
  )
}

AdditionalInformation.propTypes = {
  /**
   * Specify text overrides or additional texts
   */
  texts: PropTypes.shape({}),
  /**
   * Specify if is a warranty Item
   */
  isWarrantyItem: PropTypes.bool,
  /**
   * Specify if guarantee disclaimer to be shown
   */
  warrantyProductDetails: PropTypes.shape({})
}

export default AdditionalInformation
